import React from "react";
import styles from "../specialities.module.css";
import SpecialitiesBanner from "../../../components/Banners/Speacialities-Banner/speacialities-banner";
import ImageWithText from "../../../components/ImageWithText/ImageWithText";
import SpecialityFeatures from "../../../components/SpecialityFeatures/specialityFeatures";
import TextOnly from "../../../components/TextOnly/textOnly";
import MetaTags from "../../../components/MetaTags";

const AnalyticsReporting = () => {
  const bannerContent = {
    heading: "Analytics and Reporting",
    subText: (
      <>
      Our Analytics and Reporting solution provides a complete overview of your business operations. Get important information about your business’s performance and stay on top of identifiable trends. With our solutions for analytics and reporting, get the most out of your business and your data.
</>
    ),
  };

  const specialityAbout = [
    {
      aboutImage: {
        url: "assets//Speciality-Images/Real-Time-Data-Insights.webp",
        alt: "Real-Time Data Insights",
      },
      aboutTitle: { title: `Real-Time Data Insights`, highlightedTitle: "" },
      aboutDescription: (
        <>
Access live updates on sales, deliveries, customer feedback, and operational efficiency, empowering you to act instantly.</>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Customizable-Dashboards.webp",
        alt: "Customizable Dashboards",
      },
      aboutTitle: { title: `Customizable Dashboards`, highlightedTitle: "" },
      aboutDescription: (
        <>
Tailor your analytics dashboard to display key metrics and data points most relevant to your business goals.</>
      ),
      flexReverse: "true",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Vendor-and-Fleet-Analytics.webp",
        alt: "Vendor and Fleet Analytics",
      },
      aboutTitle: { title: `Vendor and Fleet Analytics`, highlightedTitle: "" },
      aboutDescription: (
        <>
Evaluate vendor performance and fleet efficiency to pinpoint areas of improvement and boost overall productivity.</>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Customer-Behavior-Tracking.webp",
        alt: "Customer Behavior Tracking",
      },
      aboutTitle: { title: `Customer Behavior Tracking`, highlightedTitle: "" },
      aboutDescription: (
        <>
Gain deep insights into customer preferences, purchasing patterns, and feedback to improve user satisfaction and retention.</>
      ),
      flexReverse: "true",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Comprehensive-Reporting-Tools.webp",
        alt: "Comprehensive Reporting Tools",
      },
      aboutTitle: { title: `Comprehensive Reporting Tools`, highlightedTitle: "" },
      aboutDescription: (
        <>
Generate detailed reports to share with your team or stakeholders, supporting data-driven decision-making at every level.</>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Predictive-Insights.webp",
        alt: "Predictive Insights",
      },
      aboutTitle: { title: `Predictive Insights`, highlightedTitle: "" },
      aboutDescription: (
        <>
Leverage historical data and AI-powered analytics to forecast trends and prepare for future opportunities and challenges.</>
      ),
      flexReverse: "true",
    },
  ];

  const featurePoints = [
    <>Real-time KPI tracking and updates</>,
    <>Sales and revenue analytics for all stakeholders</>,
    <>Trend analysis and customer segmentation</>,
    <>Exportable reports in multiple formats</>,
    <>Alerts for critical metrics and anomalies</>
  ];

  const finalThoughts = [
    {heading: `Unleash the Power of Your Data`},
    {subText: `With Ninjas Code’s Analytics and Reporting solution, your data becomes a powerful tool to optimize operations, enhance customer experiences, and grow your business. Contact us today to start unlocking your business’s full potential!`},
  ]

  return (
    <div>
       <MetaTags
     title="Get a Perfect Analytics & Reporting Solution for Business"
     description="Gain actionable insights with a Ninjas Code Analytics and Reporting solution. Custom dashboards, real-time updates, and predictive trends to grow your business."
     />
      <SpecialitiesBanner content={bannerContent} />

      <div className={styles.specialitiesAbout}>
        <div className={styles.container}>
          <h2>Why Choose Our Analytics and Reporting Solution?</h2>
          <ImageWithText aboutContent={specialityAbout} />
        </div>
      </div>

      <SpecialityFeatures features={featurePoints} />

      <TextOnly 
      content={finalThoughts}
      width
      />
    </div>
  );
};

export default AnalyticsReporting;
